import Rete from "rete";
import {ToggleControl, ToggleSocket } from "../../rete-controls/ToggleControl.js"


export default class ToggleComponent extends Rete.Component {
  constructor() {
    super("Toggle"); // name
    this._categories = ["Conditionals", "tryMe"];
  }

  builder(node) {
    let out1 = new Rete.Output("out1", "On/Off", ToggleSocket);
    let toggleControl = new ToggleControl(this.editor, "onoff", "ON","OFF");

    return node
      .addOutput(out1)
      .addControl(toggleControl);
  }

  worker(node, inputs, outputs) {
    outputs['out1'] = node.data.onoff === true;    
  }
}

//ReteComponentStore.add(new NumberAdderComponent());